import { connect, Dispatch } from 'react-redux';
import { AppState } from 'pages/app/state';
import { languageSelector } from 'pages/settings/selectors';
import { NotificationComponent } from './component';
import { DismissNotificationAction } from './actions';
import { Guid } from 'types/guid';

const mapStateToProps = (state: AppState) => {
  return {
    language: languageSelector(state)
  };
};

function mapDisptachToProps(dispatch: Dispatch<DismissNotificationAction>) {
  return {
    dismiss: (notificationId: Guid) => { dispatch(new DismissNotificationAction(notificationId)); }
  };
}

export default connect(mapStateToProps, mapDisptachToProps)(NotificationComponent);


// WEBPACK FOOTER //
// ./src/components/notification/index.ts